import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

/** Multi-select filter shape of the test-step library overview, serialized into `SavedView.filtersJson` (NEX-788). */
export interface TestStepSavedViewFilters {
  query: string | null;
  category: string[];
  status: string[];
  author: string[];
}

const EMPTY_TEST_STEP_SAVED_VIEW_FILTERS: TestStepSavedViewFilters = {
  query: null,
  category: [],
  status: [],
  author: [],
};

export function parseTestStepSavedViewFilters(filtersJson: string | null): TestStepSavedViewFilters {
  return parseSavedViewFilters(filtersJson, EMPTY_TEST_STEP_SAVED_VIEW_FILTERS);
}

export function buildTestStepSavedViewFiltersJson(filters: TestStepSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}
